module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div class=\"confidential\" ng-switch=\"props.countryCode\">\n        <span class=\"full-address\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-address-components/src/address-display/template.html
 ** module id = 309
 ** module chunks = 1
 **/